export const mark = (items, value) => {
  return items.some((e) => e.fullDescription.includes(value));
};

export const thirdLevel = (row) => {
  //Taking into account that the articles are not standardized, we must point out some conditions
  if (row.original.fullDescription?.includes("Art. 57")) {
    return false;
  }
  if (row.original.fullDescription?.includes("Art. 56")) {
    return true;
  }
  return !row.original.articleDescription.slice(0, 2).includes(")") && row.original.amount !== null;
};

export const secondLevel = (row) => {
  return row.canExpand && row.original.articleName !== null;
};
